import {
    formatError,
    login,
    saveTokenInLocalStorage,
} from '../../services/AuthService';
import {
    LOGIN_CONFIRMED_ACTION,
    LOGIN_FAILED_ACTION,
    LOADING_TOGGLE_ACTION,
    LOGOUT_ACTION
} from './AuthTypes';

export function Logout(navigate) {
    localStorage.removeItem('userDetails');
    document.cookie = 'token=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;';
    navigate('/login');
    
    return {
        type: LOGOUT_ACTION,
    };
}

export function loginAction(credentials, navigate) {
    return (dispatch) => {
        dispatch(loadingToggleAction(true));
        
        login(credentials.username, credentials.password)
            .then((response) => {
                console.log('Login Response:', response);
                if (response.success) {
                    const authData = {
                        token: response.data.token,
                        user: response.data.user
                    };

                    saveTokenInLocalStorage(authData);
                    dispatch(loginConfirmedAction(authData));
                    
                    // Add a small delay to ensure token is set
                    setTimeout(() => {
                        navigate('/dashboard', { replace: true });
                    }, 100);
                } else {
                    dispatch(loginFailedAction(response.message || 'Login failed'));
                }
            })
            .catch((error) => {
                console.error('Login Error:', error);
                const errorMessage = formatError(error.response?.data || error);
                dispatch(loginFailedAction(errorMessage));
            })
            .finally(() => {
                dispatch(loadingToggleAction(false));
            });
    };
}

export function loginFailedAction(data) {
    return {
        type: LOGIN_FAILED_ACTION,
        payload: data,
    };
}

export function loginConfirmedAction(data) {
    return {
        type: LOGIN_CONFIRMED_ACTION,
        payload: data,
    };
}

export function loadingToggleAction(status) {
    return {
        type: LOADING_TOGGLE_ACTION,
        payload: status,
    };
}
